/**
 * Work Item Context Staleness API (FLOW-582)
 *
 * The GET reads a precomputed flag — the comparison happened at write time in
 * the database, not here and not on render.
 */
import { api } from "./client";
import type {
  WorkItemBusinessContext,
  WorkItemContextStaleness,
  WorkItemId,
} from "./types";

export async function getContextStaleness(
  workItemId: WorkItemId,
): Promise<WorkItemContextStaleness> {
  return api.get<WorkItemContextStaleness>(
    `/work-items/${workItemId}/context-fingerprint`,
  );
}

/** Re-snapshots the item's current context, clearing the staleness flag. */
export async function seedContextFingerprint(
  workItemId: WorkItemId,
): Promise<WorkItemContextStaleness> {
  return api.post<WorkItemContextStaleness>(
    `/work-items/${workItemId}/context-fingerprint`,
    {},
  );
}

/**
 * Evaluates the recorded drift reasons against the item and returns a
 * verdict (FLOW-758). `assessment` on the response DTO comes back null when
 * the item was not stale to begin with, or the reasons moved mid-call.
 */
export async function assessContextRelevance(
  workItemId: WorkItemId,
): Promise<WorkItemContextStaleness> {
  return api.post<WorkItemContextStaleness>(
    `/work-items/${workItemId}/context-fingerprint/assessment`,
    {},
  );
}

/** The project goals, constraints and business priority behind an item (FLOW-584). */
export async function getBusinessContext(
  workItemId: WorkItemId,
): Promise<WorkItemBusinessContext> {
  return api.get<WorkItemBusinessContext>(
    `/work-items/${workItemId}/business-context`,
  );
}
